import { trim } from 'lodash';
import { array, mixed, object, string } from 'yup';

import { messages } from '../../../../../data/utils/form.utils';
import { FileItemData } from '../../../../../data/utils/upload.utils';

export const schema = object()
  .shape({
    files: array(mixed<FileItemData>())
      .min(1, messages.required.id)
      .default([]),
    text: string().transform(trim).default(''),
  })
  .required()
  .noUnknown();
